export default __webpack_public_path__ + "static/108000-777b0e1cb84823555095c69c0eea2e4b.jpg";